import { useSearchParams } from "react-router-dom"
import { useSelector } from "react-redux"
import { RootState } from "../app/store"
import placeholder from "../assets/plchldr.jpg"
import { CiHeart } from "react-icons/ci"
import { FiShare } from "react-icons/fi"
import { FaBookmark } from "react-icons/fa6"

import { Helmet } from "react-helmet"

export default function Post() {
  const [searchParams] = useSearchParams()
  const postId = searchParams.get("id")
  const post = useSelector((state: RootState) => 
    state.posts.items.find(p => p.id === postId)
  )

  if (!post) {
    return (
      <div className="max-w-3xl mx-auto p-4 text-center py-20">
        <h1 className="text-2xl font-bold">Post not found</h1>
      </div>
    )
  }

  return (
    <>
      <Helmet>
        <title>{post.title} | Muhammed Mashady Blog</title>
        <meta name="description" content={post.description.slice(0, 160)} />
        <meta property="og:title" content={post.title} />
        <meta property="og:description" content={post.description.slice(0, 160)} />
        {post.picture && <meta property="og:image" content={post.picture} />}
        <meta property="og:type" content="article" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={post.title} />
        <meta name="twitter:description" content={post.description.slice(0, 160)} />
        {post.picture && <meta name="twitter:image" content={post.picture} />}
      </Helmet>
      <div className="max-w-3xl mx-auto p-4">
      <div className="max-h-[450px] my-4 overflow-hidden rounded">
        <img className="w-full h-full object-cover" src={post.picture || placeholder} alt={post.title} />
      </div>
      <div className="">
        <div className="uppercase text-[1.1rem] my-6">
          <span className="text-[#6b69f2] cursor-pointer ">
            {post.category || "General"}
          </span>{" "}
          <span className="mx-2">/</span> {post.title}
        </div>
        <div className="">
          <h1 className="text-[42px] font-bold text-[#f5f1f9] tracking-[-0.011em]">
            {post.title}
          </h1>
        </div>
        <div className=" flex justify-between border-y-[0.1px] border-[#79747b1f] py-5 px-2 my-6">
          <div className="">
            <CiHeart
              fontSize={25}
              className="text-[#79747b] hover:text-[#f5f1f9] general-animation cursor-pointer"
            />
          </div>
          <div className="flex text-sm text-gray-500 items-center">
            {new Date(post.createdAt).toLocaleDateString()}
          </div>
          <div className="flex">
            <FiShare
              fontSize={22}
              className="mr-4 text-[#79747b] hover:text-[#f5f1f9] general-animation cursor-pointer"
            />
            <FaBookmark
              fontSize={22}
              className="text-[#79747b] hover:text-[#f5f1f9] general-animation cursor-pointer"
            />
          </div>
        </div>
        <div className="">
          <p className="text-[20px] break-words my-4 whitespace-pre-wrap">
            {post.description}
          </p>
        </div>
      </div>
    </div>
    </>
  )
}
